<template>
  <div class="home">
    <div class="about">Wardrobe stylist <span class="b">Audrey Brianne</span > and fashion publicist <span class="b">Tyree Robinson</span > discuss the best in costume design in Film/TV including interviews with costume designers and red carpet discussions about the stars' style.</div>
    <div class="links">
      <a href="https://podcasts.apple.com/us/podcast/the-dm/id1527521885" target="_blank"><img class="linkpic" src="../assets/apple.png"></a>
      <a href="https://open.spotify.com/show/0EFAG061b8lkJoWOQvRelj" target="_blank"><img class="linkpic" src="../assets/spotify.png"></a>
    </div>
    <img class="biopic" src="../assets/tyree.png"><img class="biopic" src="../assets/audrey.png">
    
     <div class="bios fb">
       
  <div class="profile">
        
          <img  class="pic" src="../assets/tyree.png">
          <p>
            HI MY NAME IS TYREE- OF TYREE'S STYLE!<br/><br/>
            I AM A MULTIFACETED ARTIST WITH A BACKGROUND IN STYLING,
            MERCHANDISING, MARKETING AND PUBLIC RELATIONS. I HAVE 10+
            YEARS OF EXPERIENCE IN THE FASHION INDUSTRY AND UNDERSTAND
            THE NEEDS OF VARIOUS CLIENTELE FROM LUXURY TO AN INTERNATIONAL
            AUDIENCE.<br/><br/>

            TYREE'S STYLE IS NOT JUST ABOUT MY STYLE, BUT YOURS TOO!
            HERE I WILL SHARE MY STYLE TIPS AND TRICKS AS WELL AS OTHER
              VENTURES TO ENHANCE OUR STYLE COLLECTIVELY.<br/><br/>

            WELCOME TO TYREE'S STYLE.<br/><br/>

            
            <a href="//tyreesstyle.com" target="_blank">TYREESSTYLE.COM</a>
          </p>
      </div>
      
      <div class='vert'></div>
     
           <div class="profile">
          <img class="pic" src="../assets/audrey.png">
          <p>
            AUDREY BRIANNE IS AN LA-BASED WARDROBE STYLIST. HER 
            CLIENTELE INCLUDES A WHO'S-WHO OF CAPTIVATING TALENT
            INCLUDING A WIDE-RANGE OF 'YOUNG HOLLYWOOD,' TV & FILM
            ACTORS AND MUSICIANS.<br/><br/>

            FOR OVER A DECADE, AUDREY HAS BEEN STYLING WITH AN EMPHASIS
            ON CELEB RED CARPET APPEARANCES AND EDITORIAL.<br/><br/>

            SHE HAS BEEN A RECURRING CELEB STYLIST CONTRIBUTOR ON TMZ'S 
            TOOFAB AND IS CURRENTLY A CONTRIBUTING WRITER FOR THE LATERALS
            MAGAZINE AND MENTAL HEALTH AWARENESS INCENTIVE 'CHECK IN
            WITH YOU'.<br/><br/>
            <a href="http://audreybrianne.com" target="_blank">AUDREYBRIANNE.COM</a>
          </p>
        </div>
        
    </div>
  </div>
</template>

<script>
// @ is an alias to /src


export default {
  name: 'Home',
  components: {
    
  }
}
</script>
